import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/app/contexts/LanguageContext";
import { AuthProvider } from "@/app/contexts/AuthContext";
import { queryClient } from "@/app/services/queryClient";
import { router } from "@/app/router";

/** App root — wrap mọi context (language → auth → query) rồi mount router.
 *  i18next đã init qua side-effect import trong main.tsx. */
export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <Toaster richColors position="top-right" duration={2500} />
        </QueryClientProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}
